import type { ApiEventId } from '#/api/types/ApiTypedId';
import type { ApiOwnRsvp } from '#/modules/listing/events/api/types/ApiRsvpResponse';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  ownRsvp: ApiOwnRsvp | null;
};

function mapResponse(response: ApiResponse) {
  return response.ownRsvp;
}

const endpoint = new FetchEndpoint({
  urlFactory: (eventId: ApiEventId) => `/data/website/events/${eventId}/rsvp`,
  mapResponse,
});

// Exports

export const listingApiFetchOwnRsvp = endpoint.client();
